import React, { useState, useEffect } from "react";
import { Table, Button } from "antd";
import axios from "axios";
// import { Route } from "react-router-dom";
// import RecordPatient from "../PatientRecords/PatientRecord";

const PatientTable = (props) => {
  const [patient, setPatient] = useState([]);
  // const [name, setName] = useState([]);

  useEffect(() => {
    axios
      .get("https://herohac.firebaseio.com/HiS/Patients.json")
      .then((res) => setPatient(res.data));
  }, []);

  const columns = [
    {
      title: "Photo",
      dataIndex: "photo",
      key: "photo",
      align: "center",
      render: (el) => (
        <img
          style={{
            width: 50,
            height: 50,
            borderRadius: 25,
            objectFit: "cover",
          }}
          src={el}
          alt="Profile"
        />
      ),
    },
    { title: "Name", dataIndex: "name", key: "name", align: "center" },
    { title: "Date of Birth", dataIndex: "dob", key: "dob", align: "center" },
    { title: "Gender", dataIndex: "gender", key: "gender", align: "center" },
    {
      title: "Contact Number",
      dataIndex: "contactnumber",
      key: "contactnumber",
      align: "center",
    },
    {
      title: "",
      key: "nameProp",
      dataIndex: "nameProp",
      render: (ele) => (
        <Button
          type="link"
          style={{ color: "#9254DE", fontWeight: "500" }}
          onClick={() => props.props.history.push("/patient-records")}
          // href="/patient-records"
        >
          Request access
        </Button>
      ),
      align: "center",
    },
  ];

  const data = [];
  for (let i = 1; i < patient.length; ++i) {
    data.push({
      key: patient[i].AdhaarID,
      photo: patient[i].P_Image,
      name: patient[i].P_Name,
      dob: patient[i].P_DOB,
      gender: patient[i].Gender,
      contactnumber: patient[i].P_Phone,
      nameProp: patient[i].P_Name,
    });
  }

  return (
    <Table
      className="components-table-demo-nested"
      columns={columns}
      dataSource={data}
      size="small"
    />
  );
};

export default PatientTable;
